export default "/static/webpack/media/target.d2da933e.svg";